import { render, staticRenderFns } from "./full-list.vue?vue&type=template&id=026a1c13&scoped=true&"
import script from "./full-list.vue?vue&type=script&lang=js&"
export * from "./full-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026a1c13",
  null
  
)

export default component.exports